export default {
  user(state) {
    return state.user;
  },
  entidade(state) {
    return state.entidade;
  },
  loading(state) {
    return state.loading;
  },
  hasRoleGestorEntrega(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_GESTOR_ENTREGAS');
  },
  hasRoleCadastroProduto(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_CADASTRO_PRODUTO');
  },
  hasRoleObservadorGestao(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_OBSERVADOR_GESTAO');
  },
  hasModuleGerencia(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_COMPRADOR');
  },
  hasRoleGestorCompras(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_GESTOR_COMPRAS');
  },
  hasRoleAprovador(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_APROVADOR_COMPRAS');
  },
  hasRoleRequisicao(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_REQUISICAO');
  },
  hasModuleCompraConjunta(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_COMPRA_CONJUNTA');
  },
  hasModuleGestorFrete(state) {
    if (!state.user) {
      return false;
    }
    return state.user.roles.map(r => r.name).includes('ROLE_GESTOR_FRETE');
  },
  hasModuleGerenciaOrCompraConjunta(state, getters) {
    if (!state.user) {
      return false;
    }
    return getters.hasModuleGerencia || getters.hasModuleCompraConjunta;
  },
  hasControleEntrega(state) {
    if (!state.entidade) {
      return false;
    }
    return state.entidade.habilitadoControleEntrega;
  },
  hasIntegracaoAtiva(state) {
    if (!state.entidade) {
      return false;
    }
    return state.entidade.habilitadoEventHub;
  },
  erpCamposIntegracao(state) {
    if (!state.entidade) {
      return null;
    }
    return state.entidade.erpCamposIntegracao;
  },
};
